<template>
  <div class="">
    <!-- 轮播图 -->
    <el-carousel indicator-position="outside" style="height: 600px">
      <el-carousel-item v-for="(item, index) in banner" :key="index" style="height: 600px">
        <img :src="item.url" alt="Carousel Image" />
      </el-carousel-item>
    </el-carousel>
    <!-- 中间内容 -->
    <div class="x-home-content">
      <div class="x-home-tip">
        <div class="x-trace">
          <el-input v-model="form.desc" class="x-trace-input" placeholder="请输入运单号"></el-input>
          <el-button class="x-trace-btn" @click="search">查询</el-button>
        </div>
        <div class="x-order-place" @click="orderPlace">
          <el-image
            class="x-order-place-img"
            :src="require('@/assets/index/jiao.png')"
            fit="contain"
          ></el-image>
          <span>在线下单</span>
        </div>
      </div>
      <!-- 主营 -->
      <div class="x-common">
        <div class="x-common-box">
          <p class="x-common-title">主营业务</p>
          <div class="x-common-cont">
            <div class="x-common-tab-box">
              <div class="x-common-tab-item" :class="tabIndex == 0 ? 'x-common-tab-item-active' : ''" @click="tabIndex = 0">快递</div>
              <div class="x-common-tab-item" :class="tabIndex == 1 ? 'x-common-tab-item-active' : ''" @click="tabIndex = 1">物流</div>
            </div>
            <div class="x-common-item">
              <div class="x-common-item-left">
                <p class="x-common-item-titles">快递业务</p>
                <ul>
                  <li class="x-common-item-futitle" v-for="(item,index) in tabList[tabIndex].cont" :key="index">{{ item }}</li>
                </ul>
              </div>
              <div class="x-common-item-right">
                <img :src="tabList[tabIndex].img" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 新闻资讯 -->
      <div class="x-news">
        <div class="x-news-title">新闻资讯</div>
        <div class="x-news-box">
          <div class="x-news-item" v-for="(item,index) in newsList" :key="index" @click="goToNewsDetail(index)">
            <div class="x-news-item-img">
              <img :src="item.img" alt="" />
            </div>
            <div class="x-news-item-r">
              <div class="x-news-item-title">{{ item.title }}</div>
              <div class="x-news-item-content">
                {{ item.brief }}
              </div>
            </div>
          </div>
        </div>
        <p class="seen-all" @click="goToNews">查看全部</p>
      </div>
    </div>
  </div>
</template>

<script>
import { newsList, tabList } from "@/common/news";
export default {
  data() {
    return {
      newsList: newsList(),
      tabList: tabList(),
      tabIndex: 0,
      banner: [
        {
          url: require("@/assets/banner/banner.png"),
        },
        {
          url: require("@/assets/banner/banner2.png"),
        }
        // ,{
        //   url:require("@/assets/banner/2.jpg")
        // },{
        //   url:require("@/assets/banner/3.jpg")
        // },{
        //   url:require("@/assets/banner/4.jpg")
        // }
      ],
      activeName: "first",
      form: {
        desc: "",
      },
      isShowAll: 1,
    };
  },
  methods: {
    handleBlur() {
      this.isShowAll = 2;
    },
    handleFocus() {
      this.isShowAll = 3;
    },
    search(e) {
      this.$router.push({ path: "/office/trace", query: { num: this.form.desc } });
    },
    goToNewsDetail(num) {
      this.$router.push({ path: "/newsDetail", query: { num } });
    },
    goToNews() {
      this.$router.push({ path: "/news" });
    },
    orderPlace(){
      this.$router.push({ path: "/order/place" });
    }
  },
};
</script>
<style lang="scss" scoped>
.x-home-content {
  width: 100%;
  .x-home-tip {
    width: 1200px;
    height: 120px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .x-trace {
      width: 800px;
      height: 60px;
      display: flex;
      border: 1px solid #e6e6e6;
      background: #fff;
      border-radius: 6px 6px 6px 6px;
      box-sizing: border-box;
      padding: 4px;
      /deep/.el-input__inner {
        height: 52px !important;
        border: none;
        font-size: 16px;
        padding: 0 15px 0 30px;
      }
      .x-trace-btn {
        width: 140px;
        background: #00aecf;
        color: #fff;
        font-size: 16px;
        margin-left: 20px;
        border-radius: 8px;
      }
    }
    .x-order-place {
      width: 360px;
      height: 57px;
      background: #ffffff;
      border-radius: 6px 6px 6px 6px;
      border: 2px solid #00aecf;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      .x-order-place-img {
        width: 30px;
        height: 28px;
        margin-right: 10px;
      }
      span {
        font-size: 18px;
        font-weight: 500;
        color: #00aecf;
      }
    }
  }
  .x-common {
    width: 100%;
    background: #fff;
    .x-common-box {
      width: 1200px;
      margin: 0 auto;
      box-sizing: border-box;
      padding: 30px 0;
      .x-common-title {
        width: 100%;
        font-size: 36px;
        text-align: center;
        font-weight: bold;
      }
      .x-common-cont {
        width: 100%;
        .x-common-tab-box {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-around;
          margin-bottom: 60px;
          .x-common-tab-item {
            width: 580px;
            height: 60px;
            background: #edfbfe;
            border-radius: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            font-weight: 500;
            color: #00aecf;
            cursor: pointer;
          }
          .x-common-tab-item-active {
            background: #00aecf;
            color: #fff;
          }
        }
        .x-common-item {
          width: 100%;
          height: 400px;
          display: flex;
          justify-content: space-between;
          box-sizing: border-box;
          padding: 10px;
          .x-common-item-left {
            box-sizing: border-box;
            padding-left: 20px;
            .x-common-item-titles{
              font-family: HarmonyOS_Sans_SC_Bold;
              font-size: 30px;
              color: #1A1A1A;
              text-align: left;
              font-weight: 500;
            }
            ul{
              text-decoration: none; 
                .x-common-item-futitle{
                font-size: 18px;
                text-align: left;
                margin: 0 0 10px 0;
                padding: 0;
                color: rgba($color: #000000, $alpha: 0.65);

              }
            }
          }
          .x-common-item-right {
            width: 619px;
            height: 379px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 50px;
            flex-shrink: 0;
          }
        }
      }
    }
  }
  // 新闻资讯
  .x-news {
    width: 1100px;
    margin: 0 auto;
    .x-news-title {
      width: 100%;
      font-size: 20px;
      height: 120px;
      line-height: 120px;
      text-align: center;
      font-weight: bold;
    }
    .x-news-box {
      width: 100%;
      display: flex;
      flex-direction: column;
      .x-news-item {
        width: 100%;
        height: 259px;
        background: #FFFFFF;
        box-shadow: 4px 0px 10px 0px #CDCDCD;
        border-radius: 6px;
        margin-bottom: 10px;
        cursor: pointer;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 4px;
        .x-news-item-img {
          width: 408px;
          height: 248px;
          border-radius: 8px;
          margin-right: 30px;
          img {
            width: 408px;
            height: 248px;
            border-radius: 8px;
          }
        }
        .x-news-item-r{
          width: 600px;
          .x-news-item-title {
            height: 40px;
            width: 100%;
            font-size: 18px;
            line-height: 30px;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            box-sizing: border-box;
            padding: 0 15px;
            text-align: left;
            color: #000;
            font-weight: 500;
          }
          .x-news-item-content {
            width: 100%;
            height: 155px;
            font-size: 14px;
            line-height: 28px;
            overflow: hidden;
            border-radius: 0 0 8px 8px;
            box-sizing: border-box;
            padding: 15px;
            text-align: left;
            color: rgba($color: #000000, $alpha: 0.65);
          }
        }

      }
    }
    .seen-all {
      width: 150px;
      height: 44px;
      text-align: center;
      line-height: 44px;
      font-size: 16px;
      background: #00aecf;
      color: #fff;
      margin: 0  auto;
      cursor: pointer;
      border-radius: 22px;
      margin: 20px auto 60px;
    }
  }
}
</style>
